module.exports = __webpack_public_path__ + "static/media/AvenirNext-Regular.2ace005a.woff";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/AvenirNext-Regular.woff
// module id = 606
// module chunks = 0